export type TagQueryDataDisplay = 'number' | 'text' | 'check' | 'button' | 'html';
